import Blacklist from '../blacklist/Blacklist'
import { DEFAULT_REFRESH_INTERVAL, timeout } from '../constants'
import { Device } from '../helpers'
import { domReady } from '../helpers/DOM'
import Logger from '../helpers/Logger'
import WebModel from '../models/WebModel'
import PrebidFacade from '../prebidFacade/PrebidFacade'
import { Slot } from '../slots/Slot'
import SlotFactory from '../slots/SlotFactory'

export const MEDIAVINE_VIDEO_URL = '//video.mediavine.com/videos/'

/**
 * Adhesion class
 * Responsible for displaying Adhesion slots
 */
export default class Adhesions {
  private slotId
  createdSlot: Slot | undefined

  constructor(
    readonly webModel: WebModel,
    readonly slotFactory: SlotFactory,
    readonly prebidFacade: PrebidFacade,
    readonly blacklist: Blacklist
  ) {
    let fillAdhesion = false

    if (Device.isMobile) {
      fillAdhesion = webModel.adhesion_mobile
      this.slotId = 'adhesion_mobile'
    } else if (Device.isTablet) {
      fillAdhesion = webModel.adhesion_tablet
      this.slotId = 'adhesion_tablet'
    } else {
      fillAdhesion = webModel.adhesion_desktop
      this.slotId = 'adhesion_desktop'
    }

    // Skip if adhesions are not turned on for this device
    if (!fillAdhesion) {
      return
    }
    domReady(() => {
      const adhesionSlotModel = this.setupAdhesionSlot()
      this.createdSlot = this.createAndDisplaySlot(adhesionSlotModel)
    })
  }

  private createAndDisplaySlot(slotModel: ISlotModel): Slot | undefined {
    try {
      const slot = this.slotFactory.new(slotModel)

      return slot
    } catch (e) {
      Logger.debug(e)
    }
  }

  private setupAdhesionSlot(): ISlotModel {
    const adhesionSlot: ISlotModel = {
      adUnitId: this.slotId,
      type: 'Adhesion' as SlotClass,
      selector: 'body',
      insertPosition: 'beforeend',
      refreshTime: DEFAULT_REFRESH_INTERVAL || undefined
    }

    return adhesionSlot
  }
}
